import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { UseTimeZone } from '../../../../../../common/hooks/useTimeZone'
import { FORMAT, formatDateTime } from '../../../../../../helpers/datetime'
import { formatText } from '../../../../../../helpers/value'

export const BIDescription = ({ val, rowId, getDataFromRedux }) => {
  const locale = useSelector((state) => state.i18n.locale)
  const timeZone = UseTimeZone()
  const createDate = useSelector(getDataFromRedux(rowId, 'createDate'))
  const reportingYear = useSelector(
    getDataFromRedux(rowId, 'readyVersionReportingYear'),
  )

  return (
    <div className="flexColumn">
      {val ? (
        <>
          <Translate
            value="userManagement.orderManagement.orderDetail.AVAILABLE_FS_DATA"
            className="fw600"
          />
          {formatText(val)}
        </>
      ) : (
        <>
          <Translate
            value="userManagement.orderManagement.orderDetail.DATE_CREATED"
            className="fw600"
          />
          {formatDateTime(createDate, FORMAT.DATE, locale, timeZone)}
          <Translate
            value="userManagement.orderManagement.orderDetail.REPORTING_YEAR"
            className="fw600"
          />
          {formatText(reportingYear)}
        </>
      )}
    </div>
  )
}
